import React from 'react';

function SectionCard({ title, viewAllHref, viewAllLabel = 'View all', actions, children, style }) {
  return (
    <div style={{ ...styles.card, ...style }}>
      {(title || actions || viewAllHref) && (
        <div style={styles.header}>
          {title && <h3 style={styles.title}>{title}</h3>}
          <div style={styles.actions}>
            {actions}
            {viewAllHref && (
              <a href={viewAllHref} style={styles.viewAll} className="link-underline">
                {viewAllLabel} →
              </a>
            )}
          </div>
        </div>
      )}
      {children}
    </div>
  );
}

const styles = {
  card: {
    backgroundColor: 'var(--color-surface)',
    border: '1px solid var(--color-border)',
    borderRadius: '12px',
    padding: '20px 22px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '16px',
    gap: '12px',
    flexWrap: 'wrap',
  },
  title: {
    fontSize: '14px',
    fontWeight: 600,
    color: 'var(--color-ink)',
    margin: 0,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  viewAll: {
    fontSize: '13px',
    fontWeight: 600,
    color: 'var(--color-primary)',
  },
};

export default SectionCard;
